export { Card } from './chunk-JMTU5OQF.mjs';
export { Gradient } from './chunk-LISZCKCC.mjs';
export { TurborepoLogo } from './chunk-2ICYYKDX.mjs';
export { Sidebar_default as Sidebar } from './chunk-LJOVFWYR.mjs';
export { APP_ITEMS, AppSwitcher_default as AppSwitcher, detectCurrentApp, resolveAppUrl } from './chunk-WN3RTF5O.mjs';
export { DEFAULT_LANGUAGES, LanguageSwitcher_default as LanguageSwitcher } from './chunk-PASAUMN2.mjs';
import { Box, Typography, Divider, Container, Grid, TextField, Autocomplete, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem } from '@mui/material';
import { useState, useEffect } from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { z } from 'zod';
import HomeIcon from '@mui/icons-material/Home';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import { trpc } from '@repo/api-client';
import GroupIcon from '@mui/icons-material/Group';
import { useDebounce } from '@repo/utils';
import dayjs from 'dayjs';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DatePicker } from '@mui/x-date-pickers';
import PersonIcon from '@mui/icons-material/Person';
import ChurchIcon from '@mui/icons-material/Church';

var InAppBrowserGuard = ({ children }) => {
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const rules = ["Line/", "FBAN", "FBAV", "Instagram"];
    const isDetected = rules.some((rule) => userAgent.includes(rule));
    const searchParams = new URLSearchParams(window.location.search);
    const isForced = searchParams.get("inAppBrowser") === "true";
    setIsInAppBrowser(isDetected || isForced);
  }, []);
  if (!isInAppBrowser) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(0, 0, 0, 0.9)",
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        padding: 3
      },
      children: [
        /* @__PURE__ */ jsx(Box, { sx: { position: "absolute", top: 16, right: 16, zIndex: 10 }, children: /* @__PURE__ */ jsx(Box, { sx: { animation: "bounce 2s infinite" }, children: /* @__PURE__ */ jsx(Typography, { variant: "h5", children: "\u2197\uFE0F" }) }) }),
        /* @__PURE__ */ jsx(Box, { sx: { position: "absolute", bottom: 16, right: 16, zIndex: 10 }, children: /* @__PURE__ */ jsx(Box, { sx: { animation: "bounce-up 2s infinite" }, children: /* @__PURE__ */ jsx(Typography, { variant: "h5", children: "\u2198\uFE0F" }) }) }),
        /* @__PURE__ */ jsx(Divider, {}),
        /* @__PURE__ */ jsxs(Container, { maxWidth: "xs", sx: { mt: 8, mb: 8 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "h5", fontWeight: "bold", children: "Open in System Browser" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "body1", sx: { mb: 2, opacity: 0.9 }, children: [
            "It looks like you are using an in-app browser. For the best experience and to ensure all features work correctly, please open this page in ",
            /* @__PURE__ */ jsx("b", { children: "Safari" }),
            " or ",
            /* @__PURE__ */ jsx("b", { children: "Chrome" }),
            "."
          ] }),
          /* @__PURE__ */ jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, width: "100%" }, children: /* @__PURE__ */ jsxs(Box, { sx: { bgcolor: "rgba(255,255,255,0.1)", p: 2, borderRadius: 2, textAlign: "left" }, children: [
            /* @__PURE__ */ jsxs(Typography, { variant: "body2", sx: { mb: 1 }, children: [
              "1. Tap the ",
              /* @__PURE__ */ jsx("b", { children: "Menu" }),
              " (\u2022\u2022\u2022) at the top or bottom right corner."
            ] }),
            /* @__PURE__ */ jsxs(Typography, { variant: "body2", sx: { mb: 1 }, children: [
              "2. Select ",
              /* @__PURE__ */ jsx("b", { children: '"Open in External Browser"' }),
              " or ",
              /* @__PURE__ */ jsx("b", { children: '"Open in Safari/Chrome"' }),
              "."
            ] })
          ] }) }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(Typography, { variant: "h6", fontWeight: "bold", sx: { mt: 4 }, children: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E2B\u0E25\u0E31\u0E01" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "body1", sx: { mb: 2, opacity: 0.9 }, children: [
            "\u0E14\u0E39\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1C\u0E48\u0E32\u0E19 In-App Browser \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49\u0E43\u0E19 ",
            /* @__PURE__ */ jsx("b", { children: "Safari" }),
            " \u0E2B\u0E23\u0E37\u0E2D ",
            /* @__PURE__ */ jsx("b", { children: "Chrome" })
          ] }),
          /* @__PURE__ */ jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, width: "100%" }, children: /* @__PURE__ */ jsxs(Box, { sx: { bgcolor: "rgba(255,255,255,0.1)", p: 2, borderRadius: 2, textAlign: "left" }, children: [
            /* @__PURE__ */ jsx(Typography, { variant: "body2", sx: { mb: 2, color: "#ddd" }, children: "1. \u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E40\u0E21\u0E19\u0E39 (\u2022\u2022\u2022) \u0E21\u0E38\u0E21\u0E02\u0E27\u0E32\u0E1A\u0E19 \u0E2B\u0E23\u0E37\u0E2D \u0E25\u0E48\u0E32\u0E07" }),
            /* @__PURE__ */ jsxs(Typography, { variant: "body2", sx: { color: "#ddd" }, children: [
              "2. \u0E40\u0E25\u0E37\u0E2D\u0E01 ",
              /* @__PURE__ */ jsx("b", { children: '"\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C"' }),
              " \u0E2B\u0E23\u0E37\u0E2D ",
              /* @__PURE__ */ jsx("b", { children: '"Open in Safari/Chrome"' })
            ] })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx("style", { children: `
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0) translateX(0);
            }
            40% {
              transform: translateY(10px) translateX(-10px);
            }
            60% {
              transform: translateY(5px) translateX(-5px);
            }
          }
          @keyframes bounce-up {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0) translateX(0);
            }
            40% {
              transform: translateY(-10px) translateX(-10px);
            }
            60% {
              transform: translateY(-5px) translateX(-5px);
            }
          }
        ` })
      ]
    }
  );
};
var InAppBrowserGuard_default = InAppBrowserGuard;
var memberLobbySchema = z.object({
  Prefix: z.string().optional(),
  Name: z.string().min(1, "Name is required"),
  Surname: z.string().min(1, "Surname is required"),
  Nickname: z.string().min(1, "Nickname is required"),
  birth_date: z.date().optional(),
  believe_date: z.date().optional(),
  registered_date: z.date(),
  Mobile: z.string().optional(),
  Email: z.string().email().optional().or(z.literal("")),
  Address: z.string().min(1, "Address is required"),
  AddPostal: z.string().optional(),
  add_provinces_id: z.number().optional(),
  add_district_id: z.number().optional(),
  add_sub_district_id: z.number().optional(),
  RecommenderID: z.number().optional(),
  recommender_text: z.string().optional(),
  ShepherdID: z.number().optional(),
  StructID: z.number().optional(),
  // LG selection
  note: z.string().optional(),
  register_at_id: z.number(),
  // Required by schema
  consent: z.boolean().refine((v) => v === true, {
    message: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02"
  }),
  website: z.string().optional(),
  // Honeypot field
  turnstileToken: z.string().optional()
  // Cloudflare Turnstile token
});
var AddressSection = () => {
  const {
    register,
    control,
    setValue,
    formState: { errors }
  } = useFormContext();
  const selectedProvinceId = useWatch({
    control,
    name: "add_provinces_id"
  });
  const selectedDistrictId = useWatch({
    control,
    name: "add_district_id"
  });
  const { data: provinces, isLoading: provincesLoading } = trpc.province.getAll.useQuery();
  const { data: districts, isLoading: districtsLoading } = trpc.district.getDistrictByProvince.useQuery(
    selectedProvinceId,
    { enabled: !!selectedProvinceId }
  );
  const { data: subdistricts, isLoading: subdistrictsLoading } = trpc.subdistrict.getByDistrictId.useQuery(
    selectedDistrictId,
    { enabled: !!selectedDistrictId }
  );
  useEffect(() => {
    setValue("add_district_id", void 0);
  }, [selectedProvinceId, setValue]);
  useEffect(() => {
    setValue("add_sub_district_id", void 0);
  }, [selectedDistrictId, setValue]);
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
      /* @__PURE__ */ jsx(HomeIcon, { sx: { mr: 1, color: "primary.main" } }),
      /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { sx: { mb: 3 } }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 3 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C",
          ...register("AddPostal"),
          error: !!errors.AddPostal,
          helperText: errors.AddPostal?.message
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 3 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "add_provinces_id",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              loading: provincesLoading,
              options: provinces || [],
              getOptionLabel: (option) => option.name_th,
              isOptionEqualToValue: (option, value) => {
                const optionId = option.id;
                const valueId = typeof value === "number" ? value : value?.id;
                return optionId === valueId;
              },
              value: provinces?.find((p) => p.id === field.value) || null,
              onChange: (_, newValue) => {
                field.onChange(newValue ? newValue.id : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E08\u0E31\u0E07\u0E2B\u0E27\u0E31\u0E14",
                  error: !!errors.add_provinces_id,
                  helperText: errors.add_provinces_id?.message
                }
              )
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 3 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "add_district_id",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              loading: districtsLoading,
              options: districts || [],
              getOptionLabel: (option) => option.name_th,
              isOptionEqualToValue: (option, value) => {
                const optionId = option.id;
                const valueId = typeof value === "number" ? value : value?.id;
                return optionId === valueId;
              },
              value: districts?.find((d) => d.id === field.value) || null,
              onChange: (_, newValue) => {
                field.onChange(newValue ? newValue.id : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E2D\u0E33\u0E40\u0E20\u0E2D/\u0E40\u0E02\u0E15",
                  error: !!errors.add_district_id,
                  helperText: errors.add_district_id?.message || (districtsLoading ? "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14..." : "")
                }
              ),
              disabled: !selectedProvinceId
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 3 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "add_sub_district_id",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              loading: subdistrictsLoading,
              options: subdistricts || [],
              getOptionLabel: (option) => option.name_th || "",
              isOptionEqualToValue: (option, value) => {
                const valueId = typeof value === "number" ? value : value?.id;
                return option.id === valueId;
              },
              value: subdistricts?.find((s) => s.id === field.value) || null,
              onChange: (_, newValue) => {
                field.onChange(newValue ? newValue.id : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E15\u0E33\u0E1A\u0E25/\u0E41\u0E02\u0E27\u0E07",
                  error: !!errors.add_sub_district_id,
                  helperText: errors.add_sub_district_id?.message || (subdistrictsLoading ? "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14..." : "")
                }
              ),
              disabled: !selectedDistrictId
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          multiline: true,
          rows: 2,
          label: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48",
          ...register("Address"),
          error: !!errors.Address,
          helperText: errors.Address?.message
        }
      ) })
    ] })
  ] });
};
var AddressSection_default = AddressSection;
var ChurchSection = ({
  selectedRecommender,
  setSelectedRecommender,
  selectedShepherd,
  setSelectedShepherd,
  lgOptions,
  lgLoading
}) => {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext();
  const [recommenderSearch, setRecommenderSearch] = useState("");
  const debouncedRecommenderSearch = useDebounce(recommenderSearch, 500);
  const { data: recommenderOptions, isLoading: recommenderLoading } = trpc.member.search.useQuery(
    debouncedRecommenderSearch,
    { enabled: debouncedRecommenderSearch.length > 0 }
  );
  const [shepherdSearch, setShepherdSearch] = useState("");
  const debouncedShepherdSearch = useDebounce(shepherdSearch, 500);
  const { data: shepherdOptions, isLoading: shepherdLoading } = trpc.member.search.useQuery(
    debouncedShepherdSearch,
    { enabled: debouncedShepherdSearch.length > 0 }
  );
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
      /* @__PURE__ */ jsx(GroupIcon, { sx: { mr: 1, color: "primary.main" } }),
      /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E08\u0E31\u0E01\u0E23" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { sx: { mb: 3 } }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "RecommenderID",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              options: recommenderOptions || [],
              loading: recommenderLoading,
              onInputChange: (_, newInputValue) => {
                setRecommenderSearch(newInputValue);
              },
              getOptionLabel: (option) => `${option.Name} ${option.Surname} (${option.Nickname})`,
              isOptionEqualToValue: (option, value) => {
                const optionId = option.MemID;
                const valueId = typeof value === "number" ? value : value?.MemID;
                return optionId === valueId;
              },
              value: selectedRecommender && selectedRecommender.MemID === field.value ? selectedRecommender : recommenderOptions?.find((opt) => opt.MemID === field.value) || null,
              onChange: (_, newValue) => {
                setSelectedRecommender(newValue);
                field.onChange(newValue ? newValue.MemID : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E1C\u0E39\u0E49\u0E41\u0E19\u0E30\u0E19\u0E33",
                  error: !!errors.RecommenderID,
                  helperText: errors.RecommenderID?.message
                }
              )
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "ShepherdID",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              options: shepherdOptions || [],
              loading: shepherdLoading,
              onInputChange: (_, newInputValue) => {
                setShepherdSearch(newInputValue);
              },
              getOptionLabel: (option) => `${option.Name} ${option.Surname} (${option.Nickname})`,
              isOptionEqualToValue: (option, value) => {
                const optionId = option.MemID;
                const valueId = typeof value === "number" ? value : value?.MemID;
                return optionId === valueId;
              },
              value: selectedShepherd && selectedShepherd.MemID === field.value ? selectedShepherd : shepherdOptions?.find((opt) => opt.MemID === field.value) || null,
              onChange: (_, newValue) => {
                setSelectedShepherd(newValue);
                field.onChange(newValue ? newValue.MemID : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E1E\u0E35\u0E48\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07",
                  error: !!errors.ShepherdID,
                  helperText: errors.ShepherdID?.message
                }
              )
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "StructID",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            Autocomplete,
            {
              fullWidth: true,
              options: lgOptions || [],
              loading: lgLoading,
              getOptionLabel: (option) => option.StrucName || "",
              isOptionEqualToValue: (option, value) => {
                const valueId = typeof value === "number" ? value : value?.StructID;
                return option.StructID === valueId;
              },
              value: lgOptions?.find((opt) => opt.StructID === field.value) || null,
              onChange: (_, newValue) => {
                field.onChange(newValue ? newValue.StructID : null);
              },
              renderInput: (params) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...params,
                  label: "\u0E40\u0E25\u0E37\u0E2D\u0E01 LG",
                  error: !!errors.StructID,
                  helperText: errors.StructID?.message
                }
              )
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12 }, children: /* @__PURE__ */ jsx(TextField, { fullWidth: true, label: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38", ...register("note") }) }),
      /* @__PURE__ */ jsxs(Grid, { size: { xs: 12 }, children: [
        /* @__PURE__ */ jsx(
          Controller,
          {
            name: "consent",
            control,
            render: ({ field }) => /* @__PURE__ */ jsx(
              FormControlLabel,
              {
                control: /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    ...field,
                    checked: !!field.value,
                    onChange: (e) => field.onChange(e.target.checked)
                  }
                ),
                label: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "primary", children: "\u0E02\u0E49\u0E32\u0E1E\u0E40\u0E08\u0E49\u0E32\u0E19\u0E34\u0E19\u0E14\u0E35\u0E43\u0E2B\u0E49\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E08\u0E31\u0E01\u0E23\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E02\u0E48\u0E32\u0E27\u0E2A\u0E32\u0E23\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E08\u0E31\u0E01\u0E23" })
              }
            )
          }
        ),
        errors.consent && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", children: errors.consent.message })
      ] })
    ] })
  ] });
};
var ChurchSection_default = ChurchSection;
var ConfirmationModal = ({
  open,
  onClose,
  formData,
  onConfirm,
  isPending,
  selectedRecommender,
  selectedShepherd,
  lgOptions
}) => {
  if (!formData) return null;
  return /* @__PURE__ */ jsxs(Dialog, { open, onClose, maxWidth: "sm", fullWidth: true, children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: "bold" }, children: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19" }) }),
    /* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsxs(Box, { sx: { py: 2 }, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "subtitle2", color: "text.secondary", gutterBottom: true, children: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E48\u0E2D\u0E19\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19" }),
      /* @__PURE__ */ jsx(Divider, { sx: { my: 2 } }),
      /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
        /* @__PURE__ */ jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E0A\u0E37\u0E48\u0E2D-\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "body1", sx: { fontWeight: "medium" }, children: [
            formData.Prefix,
            " ",
            formData.Name,
            " ",
            formData.Surname,
            " (",
            formData.Nickname,
            ")"
          ] })
        ] }),
        formData.registered_date && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: dayjs(formData.registered_date).format("DD/MM/YYYY") })
        ] }),
        formData.birth_date && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: dayjs(formData.birth_date).format("DD/MM/YYYY") })
        ] }),
        formData.believe_date && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E27\u0E31\u0E19\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E37\u0E48\u0E2D" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: dayjs(formData.believe_date).format("DD/MM/YYYY") })
        ] }),
        formData.Mobile && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: formData.Mobile })
        ] }),
        formData.Email && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E2D\u0E35\u0E40\u0E21\u0E25" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: formData.Email })
        ] }),
        formData.Address && /* @__PURE__ */ jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: formData.Address })
        ] }),
        selectedRecommender && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E1C\u0E39\u0E49\u0E41\u0E19\u0E30\u0E19\u0E33" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "body1", children: [
            selectedRecommender.Name,
            " ",
            selectedRecommender.Surname
          ] })
        ] }),
        selectedShepherd && /* @__PURE__ */ jsxs(Grid, { size: { xs: 6 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E1E\u0E35\u0E48\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "body1", children: [
            selectedShepherd.Name,
            " ",
            selectedShepherd.Surname
          ] })
        ] }),
        formData.StructID && /* @__PURE__ */ jsxs(Grid, { size: { xs: 12 }, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "LG" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body1", children: lgOptions?.find((lg) => lg.StructID === formData.StructID)?.StrucName || "-" })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs(DialogActions, { sx: { px: 3, pb: 2 }, children: [
      /* @__PURE__ */ jsx(Button, { onClick: onClose, variant: "outlined", disabled: isPending, children: "\u0E41\u0E01\u0E49\u0E44\u0E02" }),
      /* @__PURE__ */ jsx(Button, { onClick: onConfirm, variant: "contained", disabled: isPending, children: isPending ? "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01..." : "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19" })
    ] })
  ] });
};
var ConfirmationModal_default = ConfirmationModal;
var ContactSection = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext();
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
      /* @__PURE__ */ jsx(ContactPhoneIcon, { sx: { mr: 1, color: "primary.main" } }),
      /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { sx: { mb: 3 } }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D",
          ...register("Mobile"),
          error: !!errors.Mobile,
          helperText: errors.Mobile?.message
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
          ...register("Email"),
          error: !!errors.Email,
          helperText: errors.Email?.message
        }
      ) })
    ] })
  ] });
};
var ContactSection_default = ContactSection;
var DatesSection = () => {
  const { control } = useFormContext();
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
      /* @__PURE__ */ jsx(CalendarTodayIcon, { sx: { mr: 1, color: "primary.main" } }),
      /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E04\u0E31\u0E0D" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { sx: { mb: 3 } }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "birth_date",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            DatePicker,
            {
              format: "DD-MM-YYYY",
              label: "\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14 (\u0E27-\u0E14-\u0E04\u0E28)",
              value: field.value ? dayjs(field.value) : null,
              onChange: (newDate) => field.onChange(newDate ? newDate.toDate() : null),
              slotProps: { textField: { fullWidth: true } }
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "believe_date",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            DatePicker,
            {
              format: "DD-MM-YYYY",
              label: "\u0E27\u0E31\u0E19\u0E23\u0E31\u0E1A\u0E40\u0E0A\u0E37\u0E48\u0E2D (\u0E27-\u0E14-\u0E04\u0E28)",
              value: field.value ? dayjs(field.value) : null,
              onChange: (newDate) => field.onChange(newDate ? newDate.toDate() : null),
              slotProps: { textField: { fullWidth: true } }
            }
          )
        }
      ) })
    ] })
  ] });
};
var DatesSection_default = DatesSection;
var PersonalSection = () => {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext();
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
      /* @__PURE__ */ jsx(PersonIcon, { sx: { mr: 1, color: "primary.main" } }),
      /* @__PURE__ */ jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { sx: { mb: 3 } }),
    /* @__PURE__ */ jsxs(Grid, { container: true, spacing: 2, children: [
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 2 }, children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "Prefix",
          control,
          render: ({ field }) => /* @__PURE__ */ jsxs(
            TextField,
            {
              ...field,
              select: true,
              fullWidth: true,
              label: "\u0E04\u0E33\u0E19\u0E33\u0E2B\u0E19\u0E49\u0E32",
              error: !!errors.Prefix,
              children: [
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E40\u0E14\u0E47\u0E01\u0E0A\u0E32\u0E22", children: "\u0E40\u0E14\u0E47\u0E01\u0E0A\u0E32\u0E22" }),
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E40\u0E14\u0E47\u0E01\u0E2B\u0E0D\u0E34\u0E07", children: "\u0E40\u0E14\u0E47\u0E01\u0E2B\u0E0D\u0E34\u0E07" }),
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E19\u0E32\u0E22", children: "\u0E19\u0E32\u0E22" }),
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E19\u0E32\u0E07", children: "\u0E19\u0E32\u0E07" }),
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E19\u0E32\u0E07\u0E2A\u0E32\u0E27", children: "\u0E19\u0E32\u0E07\u0E2A\u0E32\u0E27" }),
                /* @__PURE__ */ jsx(MenuItem, { value: "\u0E2D\u0E37\u0E48\u0E19\u0E46", children: "\u0E2D\u0E37\u0E48\u0E19\u0E46" })
              ]
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 4 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E0A\u0E37\u0E48\u0E2D",
          ...register("Name"),
          error: !!errors.Name,
          helperText: errors.Name?.message
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 4 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25",
          ...register("Surname"),
          error: !!errors.Surname,
          helperText: errors.Surname?.message
        }
      ) }),
      /* @__PURE__ */ jsx(Grid, { size: { xs: 12, sm: 2 }, children: /* @__PURE__ */ jsx(
        TextField,
        {
          fullWidth: true,
          label: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E48\u0E19",
          ...register("Nickname"),
          error: !!errors.Nickname,
          helperText: errors.Nickname?.message
        }
      ) })
    ] })
  ] });
};
var PersonalSection_default = PersonalSection;
var RegisterHeader = ({ church }) => {
  return /* @__PURE__ */ jsxs(Box, { sx: { textAlign: "center", mb: 4 }, children: [
    /* @__PURE__ */ jsx(ChurchIcon, { sx: { fontSize: 60, color: "primary.main", mb: 2 } }),
    /* @__PURE__ */ jsxs(
      Typography,
      {
        variant: "h4",
        gutterBottom: true,
        sx: {
          fontWeight: 700,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent"
        },
        children: [
          "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E43\u0E2B\u0E21\u0E48 ",
          church
        ]
      }
    ),
    /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E04\u0E23\u0E1A\u0E16\u0E49\u0E27\u0E19" })
  ] });
};
var RegisterHeader_default = RegisterHeader;
var RegistrationDateControl = () => {
  const { control } = useFormContext();
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        position: "absolute",
        top: { xs: 10, sm: 20 },
        right: { xs: 10, sm: 20 },
        width: { xs: 150, sm: 200 },
        zIndex: 10
      },
      children: /* @__PURE__ */ jsx(
        Controller,
        {
          name: "registered_date",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx(
            DatePicker,
            {
              format: "DD-MM-YYYY",
              label: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19",
              value: field.value ? dayjs(field.value) : null,
              onChange: (newDate) => field.onChange(newDate ? newDate.toDate() : null),
              slotProps: {
                textField: {
                  fullWidth: true,
                  size: "small",
                  variant: "outlined",
                  sx: { backgroundColor: "background.paper" }
                }
              }
            }
          )
        }
      )
    }
  );
};
var RegistrationDateControl_default = RegistrationDateControl;

export { AddressSection_default as AddressSection, ChurchSection_default as ChurchSection, ConfirmationModal_default as ConfirmationModal, ContactSection_default as ContactSection, DatesSection_default as DatesSection, InAppBrowserGuard_default as InAppBrowserGuard, PersonalSection_default as PersonalSection, RegisterHeader_default as RegisterHeader, RegistrationDateControl_default as RegistrationDateControl, memberLobbySchema };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map